import {jsonMember, jsonObject} from "typedjson";

@jsonObject
export class LoadedFile {

  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: true })
  id: number;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: true })
  name: string;

  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: true })
  size: number;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: true })
  extensionFile: string;

  @jsonMember({constructor: Date, emitDefaultValue: false, isRequired: false})
  createDate: Date;

}
